// extracted by mini-css-extract-plugin
export default {"header":"MenuHeader_header--GZP","sportNameSecondHalf":"MenuHeader_sportNameSecondHalf--i4m","secondHalfIcon":"MenuHeader_secondHalfIcon--k3E"};